var mouse = {
  x: 0,
  y: 0
};

$(document).ready(function() {

  $(window).on('mousemove', function(event) {
    mouse.x = event.clientX;
    mouse.y = event.clientY;
  }).trigger('mousemove');

  initNav();
  if( $('landingpage').length ) {
    initScrolling();
  }
  initTrailer();
  initZoom();
});

var initNav = function() {
  $('[data-target="characters"]').on('touchstart click', function(e) {
    e.preventDefault();
    $('body').addClass('characters-open');
  });

  $('[data-target="film"]').on('touchstart click', function(e) {
    e.preventDefault();
    $(window).scrollTop(0);
    $('a.filter-link.active').removeClass('active');
    $(this).addClass('active');
    $('[data-column]').not('[data-column="film"]').removeClass('active');
    $('[data-column="film"]').addClass('active');

    $(window).trigger('scroll');
  });

  $('[data-target="history"]').on('touchstart click', function(e) {
    e.preventDefault();
    $(window).scrollTop(0);
    $('a.filter-link.active').removeClass('active');
    $(this).addClass('active');
    $('[data-column]').not('[data-column="history"]').removeClass('active');
    $('[data-column="history"]').addClass('active');
    $(window).trigger('scroll');
  });

  $('[data-target="true-stories"]').on('touchstart click', function(e) {
    e.preventDefault();
    $(window).scrollTop(0);
    $('a.filter-link.active').removeClass('active');
    $(this).addClass('active');
    $('[data-column]').not('[data-column="true-stories"]').removeClass('active');
    $('[data-column="true-stories"]').addClass('active');

    $(window).trigger('scroll');
  });

  $('h1').on('touchstart click', function(e) {
    e.preventDefault();
    $(window).scrollTop(0);
    $('a.filter-link.active').removeClass('active');
    $('[data-column]').removeClass('active');
    $('[data-column="all"]').addClass('active');
    $(window).trigger('scroll');
  });

  $('.characters').on('click', function() {
    $('body').removeClass('characters-open');
  });

  $('.nav-toggle').on('touchstart click', function(e) {
    e.preventDefault();
    $('body').toggleClass('mobile-nav-open');
  });


}

var scrollHandler = function() {
  if ($(window).scrollTop() > 100) {
    $('.primary-nav').addClass('active');

  } else {
    $('.primary-nav').removeClass('active');
    $('.trailer').removeClass('faded');
  }

  if ($(window).scrollTop() > $(window).height()) {
    $('.trailer').addClass('faded');
  } else {
    $('.trailer').removeClass('faded');
  }

}

var initScrolling = function() {
  $(window).on('scroll', function() {

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(scrollHandler);
    }


  }).trigger('scroll');


  var rellax = new Rellax('.rellax');

  $('.block.image').viewportChecker({
    repeat: true,
    offset: -100
  });
}
var play_video_first = true;
var initTrailer = function() {
  var trailerVid = $('#trailer-video')[0];
  
  if($('#trailer-video').lenght) {

    trailerVid.addEventListener('canplay', function() {
      if (play_video_first == true) {
        play_video_first = false;
        this.currentTime = 0;
      }

    });
    
  }

  $('.replay-btn').on('touchstart click', function(e) {
    e.preventDefault();
    trailerVid.currentTime = 0;
  });

  $('.audio-control').on('touchstart click', function(e) {
    e.preventDefault();
    if ($(this).hasClass('on')) {
      $(this).removeClass('on');
      trailerVid.muted = true;
      trailerVid.volume = 0;
    } else {
      $(this).addClass('on');
      trailerVid.muted = false;
      trailerVid.volume = 1;
    }
  });

}


function mousemoveFullscreen(event, imgHeight) {
  // Container Data
  var $section = $('.image-viewer'),
    $object = $('.image-viewer');

  if (typeof event != "undefined") {
    var posY = event.clientY;
  } else {
    var posY = mouse.y;
  }
  if (imgHeight != undefined) {
    var midY = $section.height() / 2;
  } else {
    var midY = $object.height() / 2;
  }

  var percY = 0;

  // Image Data
  var $img = $('img', $object);
  if (imgHeight != undefined) {
    var extraY = (imgHeight - $section.height()) / 2;
  } else {
    var extraY = ($img.height() - $object.height()) / 2;
  }
  var posTop = 0;

  // Top

  if (posY < midY) {
    percY = (midY - posY) / midY;
    posTop = -extraY + (percY * extraY);
  }
  // Bottom
  else {
    percY = -((posY - midY) / midY);
    posTop = -extraY + (percY * extraY);
  }


  if (event != '') $('img', $object).css('top', posTop + 'px');
  else return posTop;
}

function isTouchDevice() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e) {
    return false;
  }
}

var initZoom = function() {
  //if( !isTouchDevice() ) {
  if (isTouchDevice()) {
    $('body').addClass('is-touch-device');
  } else {
    $('body').addClass('not-touch-device');
  }
  $('.image[data-attr-fullsize]').on('click', function(e) {
    e.preventDefault();
    $('body').append('<div class="image-viewer"><a class="close" href="#"></a><img src="' + $(this).attr('data-attr-fullsize') + '" /></div>');

    $('.image-viewer').imagesLoaded(function() {
      mousemoveFullscreen();
      $('body').addClass('no-scroll');
      $('.image-viewer').addClass('visible');
      $('.image-viewer').bind('mousemove', mousemoveFullscreen);

      var trailerVid = $('#trailer-video')[0];
      if ($('#trailer-video').parents('.video-wrap').find('.audio-control').hasClass('on')) {
        trailerVid.muted = true;
        $('#trailer-video').parents('.video-wrap').find('.audio-control').removeClass('on');
      }

    }).on('click', function(e) {
      e.preventDefault();
      $('body').removeClass('no-scroll');
      $('.image-viewer').removeClass('visible');
      setTimeout(function() {
        $('.image-viewer').remove();
      }, 500);
    });
  });

  $('[data-video]').on('click', function(e) {
    e.preventDefault();
    var trailerVid = $('#trailer-video')[0];
    if ($('#trailer-video').parents('.video-wrap').find('.audio-control').hasClass('on')) {
      trailerVid.muted = true;
      $('#trailer-video').parents('.video-wrap').find('.audio-control').removeClass('on');
    }


    if (isTouchDevice()) {
      window.location.href = $(this).attr('data-video');
    } else {
      videoPlayer = '<div class="video-viewer"><a class="close" href="#"></a>';
      if( $(this).attr('data-attribution').length ) {
        videoPlayer += "<div class='attr-link'>"+$(this).attr('data-attribution')+"</div>";
      }
      videoPlayer += '  <div class="video-content">';
      videoPlayer += '    <video id="viewer-video" autoplay playsinline>';
      videoPlayer += '      <source src="' + $(this).attr('data-video') + '">';
      videoPlayer += '    </video>';
      videoPlayer += '  </div>';
      videoPlayer += '</div>';

      $('body').append(videoPlayer);

      setTimeout(function() {
        $('body').addClass('video-open no-scroll');
        $('#viewer-video')[0].onended = function() {
          closeVideoViewer();
        };
      }, 400);
    }

  });

  $('body').on('click', '.video-viewer', function(e) {
    e.preventDefault();
    closeVideoViewer();
  });

  $('body').on('click', '.attr-link a', function(e) {
    e.stopPropagation();
  });

  $('body').on('touchstart click', '.mobile-attr a', function(e) {
    e.stopPropagation();
    window.location.href = $(this).attr('href');
  });


  function closeVideoViewer() {
    $('body').removeClass('video-open no-scroll');
    setTimeout(function() {
      $('.video-viewer').remove();
    }, 500);
  }
}
